import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { Lang, LocalizedText } from '@/types';
import { DEFAULT_LANG, SUPPORTED_LANGS } from '@/i18n';

/** Joriy tilni tekshirib, qo'llab-quvvatlanadigan Lang qaytaradi. */
export function currentLang(raw: string): Lang {
  const base = raw.split('-')[0] as Lang;
  return SUPPORTED_LANGS.includes(base) ? base : DEFAULT_LANG;
}

/**
 * LocalizedText obyektidan joriy tildagi matnni oladi.
 * Til topilmasa DEFAULT_LANG ga qaytadi.
 */
export function useLocalized() {
  const { i18n } = useTranslation();
  const lang = currentLang(i18n.language);

  const l = useCallback(
    (text: LocalizedText): string => text[lang] ?? text[DEFAULT_LANG] ?? '',
    [lang],
  );

  return { l, lang };
}
